import React, { Component, PropTypes } from 'react';
import './index.scss'
import GuideItem from '../GuideItem'
class Guide extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible:this.props.visible
        }
        this.cancel = this.cancel.bind(this)
    }
    cancel(){
        const {local_name} = this.props
        localStorage.setItem(local_name,1)
        this.setState({
            visible:false
        })
    }
    render() {
        const {content,stepArray,hidenMask} = this.props
        const {visible} = this.state
        return (
            <div className={visible&&!hidenMask?'guide_modal_wrapper':''} >
                {visible?content:null}
                {visible?<GuideItem stepArray={stepArray} itemBgColor cancel={this.cancel} />:null}
            </div>
        );
    }
}



export default Guide;